module.exports = __webpack_public_path__ + "img/leonore.4bfea48b.jpg";